import { RouterProvider, createBrowserRouter } from "react-router-dom"
import HomePage from "src/pages/HomePage"
import OrderDetails from "src/pages/OrderDetails"

const RouteProvider = () => {
  const routes = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/orderDetail/:orderCode",
      element: <OrderDetails />,
    },
  ])
  return <RouterProvider router={routes} />
}

export default RouteProvider
